import {clientsClaim as workbox_core_clientsClaim} from '/Users/levinijveldt/Docker-projecten/wortelpop/wp-content/themes/pe-wortelpop/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/levinijveldt/Docker-projecten/wortelpop/wp-content/themes/pe-wortelpop/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appfonts/kievitot-bold-webfont.woff",
    "revision": "892c507f745bd72de34b890054662cbe"
  },
  {
    "url": "library/build/appfonts/kievitot-bold-webfont.woff2",
    "revision": "f28d6e45f3c7cb547e8fc72be6b1a15a"
  },
  {
    "url": "library/build/appfonts/kievitot-regular-webfont.woff",
    "revision": "d0177b7edb93a0745d306111f1352c33"
  },
  {
    "url": "library/build/appfonts/kievitot-regular-webfont.woff2",
    "revision": "16764ddb5c7c8926f96f90fdc35c057c"
  },
  {
    "url": "library/build/appfonts/troika-webfont.woff",
    "revision": "76a36573bdebeee018f48b24c62522f3"
  },
  {
    "url": "library/build/appimg/icons.0d3ec569.svg",
    "revision": "2b9b3028553e5c1d0da25ad870d62ac7"
  },
  {
    "url": "library/build/appmain.351e5776.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.351e5776.js.LICENSE.txt",
    "revision": "65bbf75e63e9e294bbf36a5e70473263"
  },
  {
    "url": "library/build/appmain.f0abf77f.css",
    "revision": null
  }
], {});








